import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=26268e7f&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"
import style0 from "./Buy.vue?vue&type=style&index=0&id=26268e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26268e7f",
  null
  
)

export default component.exports